import { FC } from 'react';
import map from 'lodash/map';
import Button from 'antd/lib/button/button';
import Divider from 'antd/lib/divider';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import InputNumber from 'antd/lib/input-number';

import MessageWrapper from 'components/MessageWrapper/MessageWrapper';
import withMap from 'components/ProductsEditMap/hocs/withMap';
import QuestionMark from 'components/QuestionMark/QuestionMark';
import { IWithProps } from 'components/ProductsEditMap/constants';
import { ErrorIcn } from 'utils/icons';

const ProductsEditMap: FC<IWithProps> = ({ inputs, isDisabled, onSubmit }) =>
  <div className="w-96">
    <h2 className="my-4">Edit MAP</h2>
    <MessageWrapper isVisible className="px-1 text-black-70 bg-black-5 dark:text-black-30 dark:bg-black-90">
      <ErrorIcn className="text-black-70 mr-1 min-w-[24px] dark:text-black-30" />
      The MAP will be applied to all of the variants and ONLY to any new sales made of this item to the dropshipper.
    </MessageWrapper>
    <Row gutter={[15, 15]} className="mt-5">
      {map(inputs, ({ span, label, tooltip, ...props }) =>
        <Col key={label} span={span}>
          <div className="mb-1 flex items-center">{label} {tooltip && <QuestionMark>{tooltip}</QuestionMark>}</div>
          <InputNumber size="large" className="w-full" {...props} />
        </Col>)}
    </Row>
    <Divider />
    <Button
      size="large"
      type="primary"
      className="block ml-auto"
      disabled={isDisabled}
      onClick={onSubmit}
    >
      Change
    </Button>
  </div>;

export default withMap(ProductsEditMap);
